import { Check, X } from 'lucide-react'
import { toast } from 'sonner'

const SUCCESS_DEFAULT_DURATION = 6000
const ERROR_DEFAULT_DURATION = 8000
const DEFAULT_DEFAULT_DURATION = 6000

export function showSuccessToast(message: string, { duration }: { duration?: number } = {}) {
  toast(message, {
    duration: duration || SUCCESS_DEFAULT_DURATION,
    icon: (
      <div className="size-5 rounded-full bg-primary text-primary-foreground grid place-items-center">
        <Check className="size-3" />
      </div>
    ),
    className: 'rounded-lg px-3 py-2 min-h-0',
  })
}

export function showErrorToast(message: string, { duration }: { duration?: number } = {}) {
  toast(message, {
    duration: duration || ERROR_DEFAULT_DURATION,
    icon: (
      <div className="size-5 rounded-full bg-destructive text-destructive-foreground grid place-items-center">
        <X className="size-3 bg-destructive text-destructive-foreground" />
      </div>
    ),
    className: 'rounded-lg px-3 py-2 min-h-0',
  })
}

export function showDefaultToast(message: string, { duration }: { duration?: number } = {}) {
  toast(message, {
    duration: duration || DEFAULT_DEFAULT_DURATION,
    icon: (
      <div className="size-5 rounded-full bg-base-background text-foreground grid place-items-center">
        <div className="size-2 rounded-full bg-background" />
      </div>
    ),
    className: 'rounded-lg px-3 py-2 min-h-0',
  })
}
